import React, { Component } from "react";

import TypoGraphy from '@material-ui/core/Typography'
import { Grid} from "@material-ui/core";
import AzureBase from "./AzureBase";

class AzureOverview extends Component {


      
  render() {
    return (
        <div>
        <div style={{ marginTop: 20, padding: 30 }}>
            <Grid container spacing={40} justify="center">
                <TypoGraphy variant="h4">
                    <center>Microsoft Azure Fundamentals</center>
                </TypoGraphy>
            </Grid>
            <div className="pad-left-page">
                <AzureBase></AzureBase>
            </div>
        
        </div>
      </div>
    );
  }
}
 
export default AzureOverview;